module.exports = __webpack_public_path__ + "static/media/main4_zh.15e69f70.png";